import React, { useState } from "react";
import Badge from "@mui/material/Badge";
import NotificationIcon from "@mui/icons-material/NotificationsNone";
import { SwipeableDrawer, useTheme } from "@mui/material";

import { useNotificationCountQuery } from "apis/Notification";

import Drawer from "./NotificationDrawer";

import colors from "assets/scss/colors.module.scss";

const NotificationDrawer = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const theme = useTheme();

  const paperProps = {
    sx: {
      padding: "20px",
      top: "70px",
      maxWidth: "505px",
      width: "100%",
      height: "calc(100vh - 70px)",
      backgroundColor:
        theme.palette.mode === "dark"
          ? colors.darkThemeNotificationDrawer
          : colors.lightThemeNotificationDrawer,
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
  };

  const { data: { data: { count: unreadNotificationCount } = {} } = {} } =
    useNotificationCountQuery(
      { pollingInterval: 60000 },
      window.location.href.includes("fire-safety")
    );

  return (
    <>
      <div onClick={() => setIsDrawerOpen(true)} style={{ cursor: "pointer" }}>
        <Badge color="error" badgeContent={unreadNotificationCount ?? 0}>
          <NotificationIcon />
        </Badge>
      </div>

      <SwipeableDrawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onOpen={() => setIsDrawerOpen(true)}
        PaperProps={paperProps}
        variant="persistent"
      >
        {isDrawerOpen && (
          <Drawer
            handleDrawerClose={() => setIsDrawerOpen(false)}
            unreadNotificationCount={unreadNotificationCount}
          />
        )}
      </SwipeableDrawer>
    </>
  );
};

export default NotificationDrawer;
